(<template>
  <div :class="styleClass">
    <h1 id="title-new-monument" v-if="!loadedForm" v-translate>Add new monument</h1>
    <h1 id="title-edit-monument" v-else v-translate>Edit monument</h1>
    <el-form :model="monumentForm"
             :rules="rules"
             ref="monumentForm"
             label-position="left"
             label-width="12em">
      <el-form-item prop="name">
        <span slot="label" v-translate>Name</span>
        <el-input id="input-name"
                  :placeholder="namePlaceholder.hu"
                  v-model="monumentForm.name.hu"
                  @focus="showName=true"></el-input>
        <el-collapse-transition>
          <div v-show="showName">
            <el-input id="input-name-en"
                      class="input-style"
                      :placeholder="namePlaceholder.en"
                      v-model="monumentForm.name.en"></el-input><br />
            <el-input id="input-name-ro"
                      class="input-style"
                      :placeholder="namePlaceholder.ro"
                      v-model="monumentForm.name.ro"></el-input>
          </div>
        </el-collapse-transition>
      </el-form-item>
      <el-form-item prop="position">
        <span slot="label" v-translate>Coordinates</span>
        <map-view id="map-view"
                  :position="monumentForm.position"
                  :is-editable="true"
                  @set-position="setPosition"></map-view>
      </el-form-item>
      <el-form-item prop="description">
        <span slot="label" v-translate>Description</span>
        <el-input id="input-desciption"
                  type="textarea"
                  :placeholder="descPlaceholder.hu"
                  v-model="monumentForm.description.hu"
                  @focus="showDesc=true"></el-input>
        <el-collapse-transition>
          <div v-show="showDesc">
            <el-input id="input-desciption-en"
                      class="input-style"
                      type="textarea"
                      :placeholder="descPlaceholder.en"
                      v-model="monumentForm.description.en"></el-input>
            <el-input id="input-desciption-ro"
                      class="input-style"
                      type="textarea"
                      :placeholder="descPlaceholder.ro"
                      v-model="monumentForm.description.ro"></el-input>
          </div>
        </el-collapse-transition>
      </el-form-item>
      <el-form-item prop="audio">
        <span slot="label" v-translate>Audio</span>
        <audio-uploader :loaded-audio="monumentForm.audio.hu"
                        lang="hu"
                        @audio-file-changed="(event) => { changeAudio(event, 'hu') }"
                        @audio-file-removed="(event) => { removeAudio(event, 'hu') }"></audio-uploader>
        <audio-uploader :loaded-audio="monumentForm.audio.en"
                        lang="en"
                        @audio-file-changed="(event) => { changeAudio(event, 'en') }"
                        @audio-file-removed="(event) => { removeAudio(event, 'en') }"></audio-uploader>
        <audio-uploader :loaded-audio="monumentForm.audio.ro"
                        lang="ro"
                        @audio-file-changed="(event) => { changeAudio(event, 'ro') }"
                        @audio-file-removed="(event) => { removeAudio(event, 'ro') }"></audio-uploader>
      </el-form-item>
      <el-form-item prop="images">
        <span slot="label" v-translate>Images</span>
        <image-uploader :images="monumentForm.images"
                        @image-added="addImage"
                        @image-removed="removeImage"></image-uploader>
      </el-form-item>
      <el-form-item prop="urls" align="left">
        <span slot="label" v-translate>References</span>
        <el-button size="small" icon="plus" type="primary" @click="addRow">
          <span v-translate>Add</span>
        </el-button>
        <el-table v-if="monumentForm.urls.length > 0"
                  :data="monumentForm.urls"
                  border
                  class-name="url-component">
          <el-table-column :label="url" align="left">
            <template slot-scope="scope">
              <el-input prefix-icon="el-icon-fa-link"
                        :placeholder="$gettext('Please enter the url')"
                        v-model="scope.row"
                        @change="saveRow(scope.$index, monumentForm.urls, scope.row)">
                <el-button slot="append"
                           size="small"
                           icon="el-icon-close"
                           @click="deleteRow(scope.$index, monumentForm.urls)"></el-button>
              </el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item>
        <el-button v-if="loadedForm" @click="cancel">
          <span v-if="loadedForm" v-translate>Cancel</span>
        </el-button>
        <el-button id="button-upload" type="primary" @click="submitForm('monumentForm')">
          <span v-if="loadedForm" v-translate>Update</span>
          <span v-else v-translate>Upload</span>
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>)

(<script>
import AudioUploader from './Audio-Uploader.vue'
import axios from 'axios'
import ImageUploader from './Image-Uploader.vue'
import MapView from './Map-View.vue'

export default {
  name: 'monument-upload-form',
  components: {
    'audio-uploader': AudioUploader,
    'image-uploader': ImageUploader,
    'map-view': MapView
  },
  props: ['loaded-form'],
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$session.exists()) {
        next()
      } else {
        next('/signin')
      }
    })
  },
  data () {
    var styleClass = this.loadedForm ? 'update-form' : 'form'
    var monumentForm = this.loadedForm || {
      name: {
        hu: '',
        en: '',
        ro: ''
      },
      description: {
        hu: '',
        en: '',
        ro: ''
      },
      audio: {
        hu: null,
        en: null,
        ro: null
      },
      position: {
        lat: null,
        lng: null
      },
      urls: [],
      images: []
    }
    monumentForm.removedAudios = []
    monumentForm.removedImages = []
    monumentForm.newImages = []
    monumentForm.removedUrls = []
    monumentForm.newUrls = []
    monumentForm.oldUrls = [].concat(monumentForm.urls)
    return {
      url: this.$gettext('Url'),
      namePlaceholder: {
        hu: this.$gettext('Name in Hungarian'),
        en: this.$gettext('Name in English'),
        ro: this.$gettext('Name in Romanian')
      },
      descPlaceholder: {
        hu: this.$gettext('Description in Hungarian'),
        en: this.$gettext('Description in English'),
        ro: this.$gettext('Description in Romanian')
      },
      styleClass,
      showName: false,
      showDesc: false,
      monumentForm,
      rules: {
        name: {
          type: 'object',
          required: true,
          fields: {
            hu: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name')},
            en: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name')},
            ro: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name')}
          }
        },
        description: {
          type: 'object',
          required: true,
          fields: {
            hu: [
              {type: 'string', required: true, message: this.$gettext('Please add description')},
              { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }
            ],
            en: [
              {type: 'string', required: true, message: this.$gettext('Please add description')},
              { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }
            ],
            ro: [
              {type: 'string', required: true, message: this.$gettext('Please add description')},
              { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }
            ]
          }
        },
        audio: {
          type: 'object',
          required: false
        },
        images: {
          type: 'array',
          required: true,
          message: this.$gettext('Please add images')
        },
        urls: {
          type: 'array',
          required: false,
          defaultField: {type: 'url', message: this.$gettext('Url is not valid')}
        },
        position: {
          type: 'object',
          required: true,
          message: this.$gettext('Please set the coordinates'),
          trigger: 'change',
          fields: {
            lat: {type: 'float', required: true, message: this.$gettext('Please set the coordinates')},
            lng: {type: 'float', required: true, message: this.$gettext('Please set the coordinates')}
          }
        }
      }
    }
  },
  methods: {
    substract (a, b) {
      return a.filter(element => b.indexOf(element) < 0)
    },
    setPosition (position) {
      this.monumentForm.position = position
    },
    uploadForm () {
      this.monumentForm.newUrls = this.monumentForm.urls
      axios({
        method: 'post',
        url: `${process.env.SERVER_URL}/monuments`,
        headers: {'Content-Type': 'application/json'},
        data: this.monumentForm,
        withCredentials: true
      })
      .then(response => {
        this.$message({
          type: 'success',
          message: response.data || response.statusText
        })
        this.$router.push('/monuments/list')
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    updateForm () {
      this.monumentForm.newUrls = this.substract(this.monumentForm.urls, this.monumentForm.oldUrls)
      this.monumentForm.removedUrls = this.substract(this.monumentForm.oldUrls, this.monumentForm.urls)
      axios({
        method: 'put',
        url: `${process.env.SERVER_URL}/monuments/${this.monumentForm.id}`,
        headers: {'Content-Type': 'application/json'},
        data: this.monumentForm,
        withCredentials: true
      })
      .then(response => {
        this.$message({
          type: 'success',
          message: response.data || response.statusText
        })
        this.$emit('close-edit')
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    cancel () {
      this.$confirm(this.$gettext('Please update if there were added or removed photo/audio files. Are you sure to close?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(() => {
        this.$emit('close-edit')
      }).catch(() => {})
    },
    addRow () {
      this.monumentForm.urls.push('')
    },
    deleteRow (index, rows) {
      rows.splice(index, 1)
    },
    saveRow (index, rows, row) {
      rows.splice(index, 1, row)
    },
    changeAudio (audioFileName, lang) {
      this.monumentForm.audio[lang] = audioFileName
    },
    removeAudio (audioFileName, lang) {
      this.monumentForm.removedAudios.push(audioFileName)
      this.monumentForm.audio[lang] = null
    },
    addImage (imageFileName) {
      this.monumentForm.newImages.push(imageFileName)
    },
    removeImage (imageFileName) {
      this.monumentForm.removedImages.push(imageFileName)
      this.monumentForm.images.splice(this.monumentForm.images.indexOf(imageFileName), 1)
      this.monumentForm.newImages.splice(this.monumentForm.newImages.indexOf(imageFileName), 1)
    },
    submitForm (formName) {
      if (this.monumentForm.images.length === 0) {
        this.monumentForm.images = [].concat(this.monumentForm.newImages)
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.loadedForm) {
            this.updateForm()
          } else {
            this.uploadForm()
          }
        }
      })
    }
  }
}
</script>)

(<style>
.input-style {
  margin-top: 1%;
}
.update-form {
  padding: 5%;
}
.url-component {
  max-height: 250px;
  width: 100%;
}
</style>)



// WEBPACK FOOTER //
// src/components/Monument-Upload-Form.vue